import api from './api'
import eventBus from '@/utils/eventBus'

const API_URL = process.env.VUE_APP_API_URL || 'https://empirecanada.ca/api';

export const locationService = {
  /**
   * Fetches all available locations
   * @returns {Promise<Array>} List of locations
   */
  async getLocations() {
    try {
      const response = await api.get(`${API_URL}/locations`)
      return response.data
    } catch (error) {
      console.error('Error fetching locations:', error)
      throw error
    }
  },

  /**
   * Fetches a location by ID
   * @param {string} id - Location ID
   * @returns {Promise<Object>} Location data
   */
  async getLocationById(id) {
    try {
      const response = await api.get(`${API_URL}/locations/${id}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching location with ID ${id}:`, error)
      throw error
    }
  },

  /**
   * Saves the selected location in sessionStorage
   * @param {Object} location - Location object
   */
  saveSelectedLocation(location) {
    sessionStorage.setItem('selectedLocation', JSON.stringify(location))
    // Emits a global event to notify all components
    eventBus.emit('selected-location-changed', location)
    console.log('Evento selected-location-changed emitido com:', location)
  },

  /**
   * Gets the selected location from sessionStorage
   * @returns {Object|null} - Location object or null if there is no selected location
   */
  getSelectedLocation() {
    const locationData = sessionStorage.getItem('selectedLocation')
    return locationData ? JSON.parse(locationData) : null
  }
}
